// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var PDebounce = require("p-debounce").default;

function make(waitOpt, fn) {
  var wait = waitOpt !== undefined ? waitOpt : 200;
  return PDebounce(fn, wait, {
              leading: false
            });
}

exports.make = make;
/* p-debounce Not a pure module */
